<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="contacts" /> Danh sách khách hàng
        </span>
        <a-input
          v-model="filter.query"
          placeholder="Tìm khách hàng theo tên..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          @change="onFilter"
        />
        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Thêm
        </a-button>
      </div>
      <a-table
        :columns="columnsAllCustomer"
        :data-source="customers"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <a
          slot="titleType"
          slot-scope="text, record"
          @click="collapseVisibleDetail(record.id)"
        >
          {{ text }}
        </a>
        <a slot="no" slot-scope="text, record, index">
          {{ index + 1 }}
        </a>

        <span slot="author" slot-scope="text">
          {{ text.author && (text.author.fullname || text.author.username) }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Chỉnh sửa
          </a-button>
        </span>
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Tải thêm
          </a-button>
        </div>
      </a-table>
    </a-card>

    <a-drawer
      v-if="visibleEdit"
      title="Chỉnh sửa"
      placement="right"
      :visible="visibleEdit"
      @close="() => (visibleEdit = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <EditCustomer
        :idCustomer="idCustomer"
        :close="() => (visibleEdit = false)"
        :refreshAfterUpdated="refreshAfterUpdated"
        :refreshAfterDeleted="refreshAfterDeleted"
      />
    </a-drawer>

    <a-drawer
      v-if="visibleAdd"
      title="Thêm mới"
      placement="right"
      :visible="visibleAdd"
      @close="() => (visibleAdd = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <AddCustomer
        :close="() => (visibleAdd = false)"
        :refreshAfterCreated="refreshAfterCreated"
      />
    </a-drawer>
  </div>
</template>
<script>
import { columnsAllCustomer } from "./constant/column";
import AddCustomer from "./components/addCustomer";
import EditCustomer from "./components/editCustomer";
import query from "./constant/query";
import debouce from "lodash/debounce";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";

const limit = 10;
const startPage = 1;

export default {
  components: { AddCustomer, EditCustomer },
  data() {
    this.onFilter = debouce(this.onFilter, 500);
    return {
      keySearch: "",
      visibleEdit: false,
      isPagination: true,
      visibleAdd: false,
      columnsAllCustomer,
      loadingList: true,
      customers: [],
      idCustomer: "",
      limit,
      currentPage: startPage,
      filter: {},
      totalPage: startPage,
    };
  },
  methods: {
    onGetAllCustomer(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getListCustomer,
          fetchPolicy: "no-cache",
          variables: {
            limit: this.limit,
            page: this.currentPage,
            query: this.filter.query,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (flag === "PAGINATION") {
            if (
              data.getListCustomer?.length >= 0 &&
              this.customers?.length >= 0
            ) {
              this.customers = this.customers.concat([...data.getListCustomer]);
            } else {
              this.customers = [...data.getListCustomer];
            }
          } else {
            if (data?.getListCustomer?.length >= 0) {
              this.customers = [...data.getListCustomer];
            }
          }

          // check is pagniation
          if (data.getListCustomer.length < limit) {
            this.isPagination = false;
          } else {
            this.isPagination = true;
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Lấy danh sách khách hàng không thành công!",
          });
          console.log("Lấy danh sách khách hàng không thành công", err);
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idCustomer = id;
        this.visibleDetail = true;
      } else {
        this.idCustomer = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idCustomer = id;
        this.visibleEdit = true;
      } else {
        this.idCustomer = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.totalPage = startPage;
      this.currentPage = startPage;
      this.onGetAllCustomer("FILTER");
    },
    refreshAfterUpdated(item) {
      this.customers = updateForUpdated(this.customers, item);
    },
    refreshAfterDeleted(item) {
      this.customers = updateForDeleted(this.customers, item);
    },
    refreshAfterCreated(item) {
      this.customers = updateForCreated({ list: this.customers, item });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetAllCustomer("PAGINATION");
      }
    },
  },
  created() {
    this.onGetAllCustomer();
  },
};
</script>
<style lang="css" scoped></style>
